import { CommonModule } from "@angular/common";
import { Component, inject, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { IFacility } from "@grainger/common/definitions/facility";
import { FacilityStatus } from "@grainger/common/enums/facility-status.enum";
import { map, Observable, tap } from "rxjs";
import { IconListItemComponent } from "../../components/icon-list-item/icon-list-item.component";
import { LogoutButtonComponent } from "../../components/logout-button/logout-button.component"
import { BackgroundImageDirective } from "../../core/directives/background-image.directive";
import { AnalyticsService } from "../../core/services/analytics.service";
import { FacilityService } from "../../core/services/facility.service";
import { WindowSizeService } from "../../core/services/window-size.service";
import { AuthService } from "@grainger/angular/services/auth.service";

@Component({
    selector: "grainger-facilities",
    imports: [CommonModule, RouterLink, BackgroundImageDirective, IconListItemComponent, LogoutButtonComponent],
    templateUrl: "./facilities.component.html",
    styleUrl: "./facilities.component.scss"
})
export class FacilitiesComponent implements OnInit {
    public facilities$: Observable<IFacility[]>;
    public isDesktop$: Observable<boolean>;

    public FacilityStatus = FacilityStatus;

    private readonly facilityService = inject(FacilityService);
    private readonly windowSizeService = inject(WindowSizeService);
    private readonly router = inject(Router);
    private readonly analyticsService = inject(AnalyticsService);
    protected authService = inject(AuthService);

    public footerLinks = [
        {
            name: 'Contracts',
            url: '/contracts',
            clickEvent: 'Clicked contracts link',
        },
        {
            name: 'Government Resource Center',
            url: 'https://gateway.on24.com/wcc/experience/grainger/1167877/4913638/gov-sales-offers',
            clickEvent: 'Clicked Government Resource Center link',
        },
        {
            name: 'Healthcare Resource Center',
            url: 'https://gateway.on24.com/wcc/experience/grainger/1167877/4915677/healthcare-sales-offers',
            clickEvent: 'Clicked Healthcare Resource Center link',
        },
    ];

    public readonly isOnlyBusinessPartner$ = this.authService.isOnlyBusinessPartner$;

    ngOnInit(): void {
        this.facilities$ = this.facilityService.getFacilities().pipe(
            tap((facilities) => {
                if (facilities.length === 1) {
                    const urlSlug = facilities[0].urlSlug;

                    console.log("Navigating to only available facility:", urlSlug);
                    this.router.navigate(["/roadmap", urlSlug]);
                }
            })
        );
        this.isDesktop$ = this.windowSizeService.isDesktop();
    }

    public trackClick(label: string): void {
        this.analyticsService.trackInteraction({
            location: "Facilities Page",
            action: "click",
            category: "button",
            label
        });
    }

    onLogoutClicked(): void {
        // optional: close menus, fire analytics, etc.
    }
}
